import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HelperService } from '../helper.service';
import { Notes } from '../notes.model';
import { AuthenticationService } from '../authentication.service';
import { Contacts } from '../contacts.model';
import { UploadService } from '../upload.service';
import { Files } from '../file.model';
import { Partners } from '../partner.model';
import { PartnerService } from '../partner.service';
import { PicklistsService } from '../picklists.service';
import { ToastService } from '../toasts.service';

@Component({
  selector: 'app-partner-form',
  templateUrl: './partner-form.component.html',
  styleUrls: ['./partner-form.component.css']
})
export class PartnerFormComponent implements OnInit {

  //declare variables
  partner: any;
  strID: string = '';
  strMessage: string = '';
  contact: Contacts = new Contacts();
  roles: any;
  @ViewChild('uploader') uploader: ElementRef;

  //inject services
  constructor(private route: ActivatedRoute, private ps: PartnerService, private pls: PicklistsService, private router: Router, private hs: HelperService, private auth: AuthenticationService, private ups: UploadService, private tst: ToastService) { }

  ngOnInit(): void {
    //initialize the lead
    this.partner = new Partners();
    this.roles = this.pls.getContactRoles();

    //get the parameter for the lead
    this.route.paramMap.subscribe(p => {
      //lead ID
      this.strID = p.get('id');

      //make sure parameter was passed (otherwise a new form)
      if (this.strID != null && this.strID != '') {
        //retrieve the lead
        this.ps.find(this.strID).subscribe(data => {
          this.partner = data;
        });
      }
    });
  }

  //save any updates
  save() {
    //see if a new record or an update to an existing record
    if (this.strID == '' || this.strID == null) {
      //create the GUID
      this.partner.id = this.hs.createGUID();
      //save the record
      this.ps.save(this.partner);
      //alert the user
      this.tst.show('Partner saved successfully.', 'Save', 'fas fa-save', { classname: 'bg-success text-white text-center toaster', delay: 2000 });
    } else {
      //update the record
      this.ps.update(this.strID, this.partner);
      //alert the user
      this.tst.show('Partner updated successfully.', 'Update', 'fas fa-edit', { classname: 'bg-success text-white text-center toaster', delay: 2000 });
    }
  }

  //return to previous page
  back() {
    this.router.navigate(['/partners']);
  }

  //save a new note
  saveNote() {
    //create a new note
    var newNote: Notes = new Notes();

    //assign values
    newNote.note = this.strMessage;
    newNote.id = this.hs.createGUID();
    newNote.dateCreated = new Date();
    var user =this.auth.getLoggedInUser();
    newNote.createdBy = user.uid;
    newNote.userName = user.displayName;

    //assign note to the customer @top of the array
    this.partner.notes.unshift(newNote);
    
    //save the note
    this.ps.update(this.strID, this.partner);

    //update the user
    this.tst.show('Note saved successfully.', 'Save', 'fas fa-save', { classname: 'bg-success text-white text-center toaster', delay: 2000 });

    //clear the message
    this.strMessage = '';
  }

  //remote a note
  deleteNote(strNoteID) {
    if (confirm("Are you sure you want to permanently delete this customer note?")) {
      //filter out this item
      this.partner.notes = this.partner.notes.filter(x => x.id != strNoteID);
      //save the result
      this.ps.update(this.strID, this.partner);
      //alert on delete
      this.tst.show('Note deleted successfully.', 'Deletion', 'fas fa-trash', { classname: 'bg-danger text-white text-center toaster', delay: 2000 });
    }
  }

  //saves a new contact
  saveContact() {
    //assign an ID
    this.contact.id = this.hs.createGUID();

    //assign note to the customer @top of the array
    this.partner.contacts.unshift(this.contact);
    
    //save the note
    this.ps.update(this.strID, this.partner);

    //update the user
    this.tst.show('Contact saved successfully.', 'Save', 'fas fa-save', { classname: 'bg-success text-white text-center toaster', delay: 2000 });

    //reset contact
    this.contact = new Contacts();
  }

  //deletes a contact
  deleteContact(strContactID) {
    if (confirm("Are you sure you want to permanently delete this customer contact?")) {
      //filter out this item
      this.partner.contacts = this.partner.contacts.filter(x => x.id != strContactID);
      //save the result
      this.ps.update(this.strID, this.partner);
      //alert on delete
      this.tst.show('Contact deleted successfully.', 'Deletion', 'fas fa-trash', { classname: 'bg-danger text-white text-center toaster', delay: 2000 });
      //reset contact
      this.contact = new Contacts();
    }
  }

  //uploads a new file
  upload(event) {
    //make sure files array exists on customer
    if (this.partner.files == null) {
      this.partner.files = [];
    }

    //loop through the files uploaded
    for (let i=0; i < event.target.files.length; i++) {
      //create a new File
      var f: Files = new Files();

      //assign data
      f.id = this.hs.createGUID();
      f.fileName = event.target.files[i].name;
      f.fileType = event.target.files[i].type;
      f.size = event.target.files[i].size;
      var user =this.auth.getLoggedInUser();
      f.uploadedBy = user.uid;
      f.dateUploaded = new Date();

      //upload
      this.ups.upload(f.id, event.target.files[i]);

      //add to the customer
      this.partner.files.push(f);
    }
    
    //save and update the user
    if (event.target.files.length > 0) {
      //save the result
      this.ps.update(this.strID, this.partner);
      //update the user
      this.tst.show(event.target.files.length + ' file(s) uploaded successfully.', 'Upload', 'fas fa-upload', { classname: 'bg-success text-white text-center toaster', delay: 2000 });
      //clear the files after upload
      this.uploader.nativeElement.value = '';
    }
  }

  //download a file
  download(strFileID) {
    this.ups.find(strFileID).subscribe(data => {
      window.open(data);
    });
  }

  //delete a file
  deleteFile(strFileID) {
    if (confirm("Are you sure you want to permanently delete this file?")) {
      //filter out this item
      this.partner.files = this.partner.files.filter(x => x.id != strFileID);
      //delete from the back end
      this.ups.delete(strFileID);
      //save the result
      this.ps.update(this.strID, this.partner);
      //alert on delete
      this.tst.show('File deleted successfully.', 'Deletion', 'fas fa-trash', { classname: 'bg-danger text-white text-center toaster', delay: 2000 });
    }
  }

}
